import { instance } from '@/apis';

import { Block, BlockV2, Reviews, ReviewSortCriteriaValue } from './types';

interface CampaignRepository {
  getCampaign(pk: string, type: string | undefined): Promise<{ block: Block }>;
  getCampaignV2(pk: string): Promise<BlockV2>;
  getCampaignReviews(
    campaign_id: number,
    page: number,
    sort_by: ReviewSortCriteriaValue,
  ): Promise<Reviews>;
}

class CampaignRepositoryImpl implements CampaignRepository {
  async getCampaign(pk: string, preview: string | undefined): Promise<{ block: Block }> {
    const url = preview ? `/campaign/preview/${pk}` : `/market/campaigns/${pk}`;
    const { data } = await instance.get(url);
    return data;
  }

  async getCampaignV2(pk: string): Promise<BlockV2> {
    const { data } = await instance.get(`/v2/market/campaigns/${pk}`);
    return data;
  }

  async getCampaignReviews(
    campaign_id: number,
    page: number,
    sort_by: ReviewSortCriteriaValue,
  ): Promise<Reviews> {
    const { data } = await instance.get(
      `/campaigns/${campaign_id}/reviews?page=${page}&sort_by=${sort_by}`,
    );
    return data;
  }
}

export const campaign: CampaignRepository = new CampaignRepositoryImpl();
